// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__15yC6","container":"styles_container__1dylZ","title":"styles_title__1TFXl","wrapper":"styles_wrapper__-QaNn","answer":"styles_answer__OWqg5"};